import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonGroup,
  Col,
  Form,
  FormCheck,
  Modal,
  Row,
} from "react-bootstrap";
import Select from "react-select";
import {
  useAddTemplateProgramMutation,
  useDeleteTemplateProgramMutation,
  useGetAllTemplateDatesQuery,
  useGetTemplateDowIdsQuery,
  useGetTemplateProgramsQuery,
  useUpdateTemplateProgramMutation,
  useGetTemplateProgramQuery,
} from "../slices/templatesApiSlice.js";
import {
  useGetAllProgramsQuery,
  useGetProgramByIdQuery,
} from "../slices/programsApiSlice.js";
import { useGetAllIdentsQuery } from "../slices/identsApiSlice.js";
import { useGetAllGraphicsValueLabelQuery } from "../slices/graphicsApiSlice.js";
import {
  useGetAllGenreQuery,
  useGetAllParentalRatingQuery,
  useGetSubGenreByGenreQuery,
} from "../slices/adminApiSlice";

import { toast } from "react-toastify";

import { timeMinuteDefaults } from "../util/timeMinuteDefaults.jsx";
import { viewTime, viewDuration } from "../util/dateTimeFunctions.jsx";

const Templates = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [selectedTemplateId, setSelectedTemplateId] = useState();
  const [selectedDowId, setSelectedDowId] = useState();
  const [selectedProgramId, setSelectedProgramId] = useState();
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [showAddProgramModal, setShowProgramModal] = useState(false);
  const [genreId, setGenreId] = useState();
  const programTime = viewTime;
  const programDuration = viewDuration;

  const [deleteTemplateProgram] = useDeleteTemplateProgramMutation();
  const [addTemplateProgram] = useAddTemplateProgramMutation();
  const [updateTemplateProgram] = useUpdateTemplateProgramMutation();

  const [skipTemplateDowIds, setSkipTemplateDowIds] = useState(true);
  const [skipTemplatePrograms, setSkipTemplatePrograms] = useState(true);
  const [skipTemplateProgram, setSkipTemplateProgram] = useState(true);
  const [skipProgramById, setSkipProgramById] = useState(true);
  const [skipSubgenre, setSkipSubgenre] = useState(true);

  const addBreakChoices = [
    { addBreak: "End of Program", addId: 1 },
    { addBreak: "Every 20 Minutes", addId: 20 },
    { addBreak: "Every 30 Minutes", addId: 30 },
    { addBreak: "Once Every Hour", addId: 60 },
  ];

  const [formData, setFormData] = useState({
    programId: "",
    programHours: 0,
    programMinutes: 0,
    programIsLive: false,
    programIsLiveisDirty: false,
    programIsAvailable: false,
    programIsAvailableisDirty: false,
    programIsLocked: false,
    programIsLockedisDirty: false,
    programName: "",
    programNameisDirty: false,
    programSynopsis: "",
    programSynopsisisDirty: false,
    programSlotRuntime: 0,
    programSlotRuntimeHours: 0,
    programSlotRuntimeMinutes: 0,
    programSlotRuntimeisDirty: false,
    programParentalRating: "",
    programParentalRatingisDirty: false,
    programGenre: "",
    programGenreisDirty: false,
    programSubgenre: "",
    programSubgenreisDirty: false,
    programInProgramBreaks: 0,
    programInProgramBreaksisDirty: false,
    programPreRollFileIdent: "",
    programPreRollFileIdentisDirty: false,
    programPreRollLiveIdent: "",
    programPreRollLiveIdentisDirty: false,
    programPreRollLiveIntroIdent: "",
    programPreRollLiveIntroIdentisDirty: false,
    programPreRollFileGraphics: "",
    programPreRollFileGraphicsisDirty: false,
    programPreRollLiveGraphics: "",
    programPreRollLiveGraphicsisDirty: false,
    programPreRollLiveMedia: "",
    programPreRollLiveMediaisDirty: false,
    programPreRollFileAddBreak: 1,
    programPreRollFileAddBreakisDirty: false,
    programPreRollFileMediaRuntime: 0,
    programPreRollFileMediaRuntimeisDirty: false,
    programPreRollLiveAddBreak: 1,
    programPreRollLiveAddBreakisDirty: false,
    programPreRollLiveMediaRuntime: 0,
    programPreRollLiveMediaRuntimeisDirty: false,
    programPreRollFileMediaPaidSongs: false,
    programSeriesLinkLinkFlag: false,
    programSeriesLinkChainId: "",
  });

  const [programFormData, setProgramFormData] = useState({
    programId: "",
    programHours: 0,
    programMinutes: 0,
  });

  const [daysOfWeek, setDaysOfWeek] = useState();

  var { hours, minutes } = timeMinuteDefaults();

  const {
    data: templateDates,
    isLoading: templateDatesLoading,
    isError: templateDatesError,
  } = useGetAllTemplateDatesQuery(0);

  const { data: templateProgram } = useGetTemplateProgramQuery(
    selectedProgramId,
    {
      skip: skipTemplateProgram,
    }
  );

  const { data: programById } = useGetProgramByIdQuery(
    programFormData.programId,
    {
      skip: skipProgramById,
    }
  );

  const { data: templateDowIds } = useGetTemplateDowIdsQuery(
    selectedTemplateId,
    {
      skip: skipTemplateDowIds,
    }
  );

  const {
    data: templatePrograms,
    isLoading: templateProgramsLoading,
    isError: templateProgramsError,
  } = useGetTemplateProgramsQuery(selectedDowId, {
    skip: skipTemplatePrograms,
  });

  const { data: programs } = useGetAllProgramsQuery();

  const {
    data: idents,
    isLoading: identsLoading,
    isError: identsError,
  } = useGetAllIdentsQuery();

  const { data: graphics } = useGetAllGraphicsValueLabelQuery();

  const {
    data: parentalRating,
    isLoading: parentalRatingLoading,
    isError: parentalRatingError,
  } = useGetAllParentalRatingQuery();

  const {
    data: genre,
    isLoading: genreLoading,
    isError: genreError,
  } = useGetAllGenreQuery();

  const {
    data: subgenreData,
    // isLoading: subgenreDataLoading,
    // isError: subgenreDataError,
  } = useGetSubGenreByGenreQuery(genreId, {
    skip: skipSubgenre,
  });

  useEffect(() => {
    setGenreId(formData.programGenre);
    console.log("formData:", formData);
  }, [formData]);

  useEffect(() => {
    if (templateDates) {
      if (!(typeof selectedTemplateId === "string")) {
        setSelectedTemplateId(templateDates[0]._id);
      }
    }
    // eslint-disable-next-line
  }, [templateDates]);

  useEffect(() => {
    if (typeof selectedTemplateId === "string") {
      setSkipTemplateDowIds(false);
    }
  }, [selectedTemplateId]);

  useEffect(() => {
    if (templateDowIds) {
      setDaysOfWeek([
        { dowNumber: 0, dowText: "Sunday", dowId: templateDowIds[0]._id },
        { dowNumber: 1, dowText: "Monday", dowId: templateDowIds[1]._id },
        { dowNumber: 2, dowText: "Tuesday", dowId: templateDowIds[2]._id },
        { dowNumber: 3, dowText: "Wednesday", dowId: templateDowIds[3]._id },
        { dowNumber: 4, dowText: "Thursday", dowId: templateDowIds[4]._id },
        { dowNumber: 5, dowText: "Friday", dowId: templateDowIds[5]._id },
        { dowNumber: 6, dowText: "Saturday", dowId: templateDowIds[6]._id },
      ]);
    }
  }, [templateDowIds]);

  useEffect(() => {
    if (daysOfWeek) {
      setSelectedDowId(daysOfWeek[0].dowId);
    }
  }, [daysOfWeek]);

  useEffect(() => {
    if (typeof selectedDowId === "string") {
      setSkipTemplatePrograms(false);
    }
  }, [selectedDowId]);

  useEffect(() => {
    if (templatePrograms) {
      const isExistsProgramInTemplate = templatePrograms.find(
        (obj) => obj._id === selectedProgramId
      );

      if (!isExistsProgramInTemplate) {
        setSelectedProgramId(templatePrograms[0]._id);
      }
    }
    // eslint-disable-next-line
  }, [templatePrograms]);

  useEffect(() => {
    if (typeof selectedProgramId === "string") {
      selectedProgramId && setSkipTemplateProgram(false);
    }
  }, [selectedProgramId]);

  useEffect(() => {
    if (templateProgram) {
      const startTimeHours = Math.floor(templateProgram.startTime / 60);
      const startTimeMins = templateProgram.startTime % 60;
      setFormData({
        programId: templateProgram._id,
        programHours: startTimeHours,
        programMinutes: startTimeMins,
        programIsLive: templateProgram.isLive.isLive,
        programIsAvailable: templateProgram.isAvailable.isAvailable,
        programIsLocked: templateProgram.isLocked.isLocked,
        programIsLiveisDirty: templateProgram.isLive.isDirty,
        programIsAvailableisDirty: templateProgram.isAvailable.isDirty,
        programIsLockedisDirty: templateProgram.isLocked.isDirty,
        programName: templateProgram.name.name,
        programNameisDirty: templateProgram.name.isDirty,
        programSynopsis: templateProgram.synopsis.synopsis,
        programSynopsisisDirty: templateProgram.synopsis.isDirty,
        programSlotRuntime: templateProgram.slotRuntime.slotRuntime,
        programSlotRuntimeHours: Math.floor(
          templateProgram.slotRuntime.slotRuntime / 60
        ),
        programSlotRuntimeMinutes: templateProgram.slotRuntime.slotRuntime % 60,
        programSlotRuntimeisDirty: templateProgram.slotRuntime.isDirty,
        programParentalRating: templateProgram.parentalrating.parentalrating,
        programParentalRatingisDirty: templateProgram.parentalrating.isDirty,
        programGenre: templateProgram.Genre.Genre,
        programGenreisDirty: templateProgram.Genre.isDirty,
        programSubgenre: templateProgram.Subgenre.Subgenre,
        programSubgenreisDirty: templateProgram.Subgenre.isDirty,
        programInProgramBreaks: templateProgram.inProgramBreaks.inProgramBreaks,
        programInProgramBreaksisDirty: templateProgram.inProgramBreaks.isDirty,
        programPreRollFileIdent:
          templateProgram?.preRoll?.file?.ident?.ident || "",
        programPreRollFileIdentisDirty:
          templateProgram?.preRoll?.file?.ident?.isDirty,
        programPreRollLiveIdent:
          templateProgram?.preRoll?.live?.ident?.ident || "",
        programPreRollLiveIdentisDirty:
          templateProgram?.preRoll?.live?.ident?.isDirty,
        programPreRollLiveIntroIdent:
          templateProgram?.preRoll?.live?.introIdent?.introIdent || "",
        programPreRollLiveIntroIdentisDirty:
          templateProgram?.preRoll?.live?.introIdent?.isDirty,
        programPreRollFileGraphics:
          templateProgram?.preRoll?.file?.graphics?.graphics || "",
        programPreRollFileGraphicsisDirty:
          templateProgram?.preRoll?.file?.graphics?.isDirty,
        programPreRollLiveGraphics:
          templateProgram?.preRoll?.live?.graphics?.graphics || "",
        programPreRollLiveGraphicsisDirty:
          templateProgram?.preRoll?.live?.graphics?.isDirty,
        programPreRollLiveMedia:
          templateProgram?.preRoll?.live?.media?.media || "",
        programPreRollLiveMediaisDirty:
          templateProgram?.preRoll?.live?.media?.isDirty,
        programPreRollFileAddBreak:
          templateProgram?.preRoll?.file?.addBreak?.addBreak || 1,
        programPreRollFileAddBreakisDirty:
          templateProgram?.preRoll?.file?.addBreak?.isDirty || false,
        programPreRollFileMediaRuntime:
          templateProgram?.preRoll?.file?.mediaRuntime?.mediaRuntime || 0,
        programPreRollFileMediaRuntimeisDirty:
          templateProgram?.preRoll?.file?.mediaRuntime?.isDirty || false,
        programPreRollLiveAddBreak:
          templateProgram?.preRoll?.live?.addBreak?.addBreak || 1,
        programPreRollLiveAddBreakisDirty:
          templateProgram?.preRoll?.live?.addBreak?.isDirty || false,
        programPreRollLiveMediaRuntime:
          templateProgram?.preRoll?.live?.mediaRuntime?.mediaRuntime || 0,
        programPreRollLiveMediaRuntimeisDirty:
          templateProgram?.preRoll?.live?.mediaRuntime?.isDirty || false,
        programPreRollFileMediaPaidSongs:
          templateProgram?.preRoll?.file?.media?.paidSongs || false,
        programSeriesLinkLinkFlag:
          templateProgram.seriesLink?.linkFlag || false,
        programSeriesLinkChainId: templateProgram.seriesLink?.chainId || "",
      });
      setIsFormDirty(false);
    }
  }, [templateProgram]);

  useEffect(() => {
    setSkipProgramById(true);
    if (programById) {
      const startTime =
        programFormData.programHours * 60 +
        Number(programFormData.programMinutes);
      let programData = {
        dow: selectedDowId,
        program: programFormData.programId,
        startTime: startTime,
        name: {
          name: programById.name,
        },
        synopsis: {
          synopsis: programById.synopsis,
        },
        slotRuntime: {
          slotRuntime: programById.slotRuntime,
        },
        parentalrating: {
          parentalrating: programById.parentalrating,
        },
        Genre: {
          Genre: programById.Genre,
        },
        Subgenre: {
          Subgenre: programById.Subgenre,
        },
        inProgramBreaks: {
          inProgramBreaks: programById.inProgramBreaks,
        },
        seriesLink: {
          linkFlag: programById.programSeriesLinkLinkFlag,
          chainId: programById.programSeriesLinkChainId,
        },
        preRoll: {
          file: {
            ident: {
              ident: programById.preRoll.file.ident,
            },
            addBreak: {
              addBreak: programById.preRoll.file.addBreak,
            },
            graphics: {
              graphics: programById.preRoll.file.graphics,
            },
            media: {
              paidSongs: programById.preRoll.file.media?.paidSongs || false,
            },
          },
          live: {
            ident: {
              ident: programById.preRoll.live.ident,
            },
            addBreak: {
              addBreak: programById.preRoll.live.addBreak,
            },
            graphics: {
              graphics: programById.preRoll.live.graphics,
            },
            media: {
              media: programById.preRoll.live.media,
            },
            introIdent: {
              introIdent: programById.preRoll.live.introIdent,
            },
          },
        },
      };
      if (
        programById.preRoll.file.mediaRuntime !== undefined &&
        programById.preRoll.file.mediaRuntime !== 0
      ) {
        programData = {
          ...programData,
          preRoll: {
            ...programData.preRoll,
            file: {
              ...programData.preRoll.file,
              mediaRuntime: {
                ...programData.preRoll.file.mediaRuntime,
                mediaRuntime: programById.preRoll.file.mediaRuntime,
              },
            },
          },
        };
      }
      if (
        programById.preRoll.live.mediaRuntime !== undefined &&
        programById.preRoll.live.mediaRuntime !== 0
      ) {
        programData = {
          ...programData,
          preRoll: {
            ...programData.preRoll,
            live: {
              ...programData.preRoll.live,
              mediaRuntime: {
                ...programData.preRoll.live.mediaRuntime,
                mediaRuntime: programById.preRoll.live.mediaRuntime,
              },
            },
          },
        };
      }

      addNewTemplateProgram();

      async function addNewTemplateProgram() {
        const insertedTemplateProgram = await addTemplateProgram(programData);

        setSelectedProgramId(insertedTemplateProgram.data._id);
      }
      setProgramFormData({
        programId: "",
        programHours: 0,
        programMinutes: 0,
      });
    }
    // eslint-disable-next-line
  }, [programById]);

  useEffect(() => {
    if (typeof genreId === "string") {
      setSkipSubgenre(false);
    }
  }, [genreId]);

  const handleTemplateChange = (e) => {
    e.preventDefault();
    setSelectedTemplateId(e.target.id);
  };

  const handleSelectedDowIdChange = (e) => {
    e.preventDefault();
    setSelectedDowId(e.target.id);
  };

  const handleDeleteProgram = async (e) => {
    //
    e.preventDefault();
    try {
      if (window.confirm("Do you want to delete this program")) {
        await deleteTemplateProgram(selectedProgramId);
        setSelectedProgramId(templatePrograms[0]._id);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const startTime =
      formData.programHours * 60 + Number(formData.programMinutes);
    const programData = {
      _id: selectedProgramId,
      startTime: startTime,
      isLive: {
        isLive: formData.programIsLive,
        isDirty: formData.programIsLiveisDirty,
      },
      isAvailable: {
        isAvailable: formData.programIsAvailable,
        isDirty: formData.programIsAvailableisDirty,
      },
      name: {
        name: formData.programName,
        isDirty: formData.programNameisDirty,
      },
      synopsis: {
        synopsis: formData.programSynopsis,
        isDirty: formData.programSynopsisisDirty,
      },
      slotRuntime: {
        slotRuntime: formData.programSlotRuntime,
        isDirty: formData.programSlotRuntimeisDirty,
      },
      parentalrating: {
        parentalrating: formData.programParentalRating,
        isDirty: formData.programParentalRatingisDirty,
      },
      Genre: {
        Genre: formData.programGenre,
        isDirty: formData.programGenreisDirty,
      },
      Subgenre: {
        Subgenre: formData.programSubgenre,
        isDirty: formData.programSubgenreisDirty,
      },
      inProgramBreaks: {
        inProgramBreaks: formData.programInProgramBreaks,
        isDirty: formData.programInProgramBreaksisDirty,
      },
      seriesLink: {
        linkFlag: formData.programSeriesLinkLinkFlag,
        chainId: formData.programSeriesLinkChainId,
      },
      isLocked: {
        isLocked: formData.programIsLocked,
        isDirty: formData.programIsLockedisDirty,
      },
      preRoll: {
        file: {
          ident: {
            ident: formData.programPreRollFileIdent,
            isDirty: formData.programPreRollFileIdentisDirty,
          },
          addBreak: {
            addBreak: formData.programPreRollFileAddBreak,
            isDirty: formData.programPreRollFileAddBreakisDirty,
          },
          mediaRuntime: {
            mediaRuntime: formData.programPreRollFileMediaRuntime,
            isDirty: formData.programPreRollFileMediaRuntimeisDirty,
          },
          graphics: {
            graphics: formData.programPreRollFileGraphics,
            isDirty: formData.programPreRollFileGraphicsisDirty,
          },
          media: {
            paidSongs: formData.programPreRollFileMediaPaidSongs,
          },
        },
        live: {
          ident: {
            ident: formData.programPreRollLiveIdent,
            isDirty: formData.programPreRollLiveIdentisDirty,
          },
          addBreak: {
            addBreak: formData.programPreRollLiveAddBreak,
            isDirty: formData.programPreRollLiveAddBreakisDirty,
          },
          mediaRuntime: {
            mediaRuntime: formData.programPreRollLiveMediaRuntime,
            isDirty: formData.programPreRollLiveMediaRuntimeisDirty,
          },
          graphics: {
            graphics: formData.programPreRollLiveGraphics,
            isDirty: formData.programPreRollLiveGraphicsisDirty,
          },
          introIdent: {
            introIdent: formData.programPreRollLiveIntroIdent,
            isDirty: formData.programPreRollLiveIntroIdentisDirty,
          },
          media: {
            media: formData.programPreRollLiveMedia,
            isDirty: formData.programPreRollLiveMediaisDirty,
          },
        },
      },
    };

    const updatedTemplateProgram = await updateTemplateProgram(programData);
    setSelectedProgramId(updatedTemplateProgram.data.newProgram._id);
    toast.info(`Program In Template Edited`);
  };

  const handleFormChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    console.log("id:", id, "value:", value);
    const isDirty = id + "isDirty";
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
      [isDirty]: true,
    }));
    id === "programGenre" && setGenreId(value);
    setIsFormDirty(true);
  };

  const handleProgramFormChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setProgramFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    const isDirty = id + "isDirty";
    if (checked) {
      setFormData((prevData) => ({
        ...prevData,
        [id]: true,
        [isDirty]: true,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [id]: false,
        [isDirty]: true,
      }));
    }
    setIsFormDirty(true);
  };

  const handleClose = (e) => {
    setProgramFormData({
      ...programFormData,
      programId: "",
      programHours: 0,
      programMinutes: 0,
    });
    setShowProgramModal(false);
  };

  const handleShow = (e) => {
    e.preventDefault();
    setShowProgramModal(true);
  };

  const handleProgramChange = (e) => {
    const { value } = e.target;
    setProgramFormData({
      ...programFormData,
      programId: value,
    });
  };

  const handleGraphicsChange = (e, fieldName) => {
    const { name } = fieldName;
    const isDirty = name + "isDirty";
    setFormData((prevData) => ({
      ...prevData,
      [name]: e,
      [isDirty]: true,
    }));
    setIsFormDirty(true);
  };

  const handleProgramInsert = async (e) => {
    e.preventDefault();
    const requiredFields = ["programId"];
    if (requiredFields.some((field) => !programFormData[field])) {
      toast.error("All fields are required. Document not saved.", {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    setSkipProgramById(false);
    setShowProgramModal(false);
  };

  const viewDate = (res) => {
    const options = {
      weekday: "short",
      month: "short",
      day: "numeric",
    };
    return new Date(res).toLocaleDateString(undefined, options);
  };

  return (
    <div>
      {userInfo && (
        <>
          <Row>
            <Col>
              <ButtonGroup className="mb-2 mt-4  d-flex shadow-lg">
                {templateDatesLoading && "Loading Template Dates..."}
                {templateDatesError && "Error loading Template Dates"}
                {templateDates &&
                  templateDates.map((templateDate) => (
                    <Button
                      variant={
                        templateDate._id === selectedTemplateId
                          ? "primary"
                          : "light"
                      }
                      id={templateDate._id}
                      key={templateDate._id}
                      onClick={handleTemplateChange}
                    >
                      Valid From: {viewDate(templateDate.validFrom)}
                    </Button>
                  ))}
              </ButtonGroup>
            </Col>
          </Row>
          <Row className="mt-3 ">
            <Col>
              <ButtonGroup
                size="sm"
                className="mb-2 d-flex shadow-lg"
              >
                {daysOfWeek &&
                  daysOfWeek.map((dayOfWeek) => (
                    <Button
                      variant={
                        dayOfWeek.dowId === selectedDowId ? "primary" : "light"
                      }
                      key={dayOfWeek.dowId}
                      id={dayOfWeek.dowId}
                      onClick={handleSelectedDowIdChange}
                    >
                      {dayOfWeek.dowText}
                    </Button>
                  ))}
              </ButtonGroup>
            </Col>
          </Row>
          <Row className="mt-3 ">
            <Col className="border border-1 ">
              <Row className="mt-2 ">
                <ButtonGroup
                  size="sm"
                  vertical
                >
                  {templateProgramsLoading && "Loading Template Dates..."}
                  {templateProgramsError && "Error loading Template Dates"}
                  {templatePrograms &&
                    templatePrograms.map((program) => (
                      <Fragment key={program._id}>
                        <Button
                          key={program._id}
                          id={program._id}
                          variant={
                            selectedProgramId === program._id
                              ? "primary"
                              : "light"
                          }
                          onClick={() => setSelectedProgramId(program._id)}
                        >
                          <Row className="py-1 ">
                            <Col className="text-sm-start col-2">
                              {programTime(program.startTime)}
                            </Col>
                            <Col className="text-sm-start col-5 text-truncate">
                              {(program.name.isDirty ||
                                program.synopsis.isDirty ||
                                program.slotRuntime.isDirty ||
                                program?.preRoll?.file?.ident?.isDirty ||
                                program?.preRoll?.live?.ident?.isDirty ||
                                program?.preRoll?.live?.introIdent?.isDirty ||
                                program?.preRoll?.file?.mediaRuntime?.isDirty ||
                                program?.preRoll?.file?.addBreak?.isDirty ||
                                program?.preRoll?.live?.mediaRuntime?.isDirty ||
                                program?.preRoll?.live?.addBreak?.isDirty) &&
                                "* "}
                              {program.name.name}
                            </Col>
                            <Col className="text-sm-start col-2 text-truncate">
                              {programDuration(program.slotRuntime.slotRuntime)}
                            </Col>
                            <Col className="text-sm-end  col-3 ">
                              {program.isLive.isLive ? (
                                <span className="badge bg-danger p-2 mx-2  ">
                                  {" "}
                                </span>
                              ) : (
                                <span className="badge p-2 mx-2  "> </span>
                              )}
                              {program.isAvailable.isAvailable ? (
                                <span className="badge bg-success p-2 mx-2  ">
                                  {" "}
                                </span>
                              ) : (
                                <span className="badge p-2 mx-2  "> </span>
                              )}
                              {program.isLocked.isLocked ? (
                                <span className="badge bg-warning p-2 mx-2  ">
                                  {" "}
                                </span>
                              ) : (
                                <span className="badge p-2 mx-2  "> </span>
                              )}
                            </Col>
                          </Row>
                        </Button>
                        {program.gap < 0 && (
                          <Row className="badge text-bg-info m-auto my-2  ">
                            <Col>ERROR - Overlap {program.gap} mins</Col>
                          </Row>
                        )}
                        {program.gap > 0 && (
                          <Row className="badge text-bg-warning m-auto my-2  ">
                            <Col>ERROR - Gap {program.gap} mins</Col>
                          </Row>
                        )}
                      </Fragment>
                    ))}
                </ButtonGroup>
              </Row>
            </Col>

            <Col className="border-start-0 border  border-1 pt-2 ">
              <small>
                <Form onSubmit={handleSubmit}>
                  <Row className="align-items-center pt-2 ">
                    <Col
                      sm={3}
                      className="align-self-center text-end"
                    >
                      Name:
                    </Col>
                    <Col>
                      <Form.Group controlId="programName">
                        <Form.Control
                          size="sm"
                          className={
                            formData.programNameisDirty && "text-danger"
                          }
                          type="text"
                          placeholder="Enter program name"
                          value={formData.programName}
                          onChange={handleFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programNameisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programNameisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="pt-2 align-items-center ">
                    <Col
                      sm={3}
                      className="text-end "
                    >
                      Synopsis:
                    </Col>
                    <Col sm>
                      <Form.Group controlId="programSynopsis">
                        <Form.Control
                          className={
                            formData.programSynopsisisDirty && "text-danger"
                          }
                          size="sm"
                          as="textarea"
                          placeholder="Enter synopsis"
                          value={formData.programSynopsis}
                          onChange={handleFormChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programSynopsisisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programSynopsisisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="pt-2 align-items-center ">
                    <Col
                      xs={3}
                      className="align-self-center text-end "
                    >
                      Start Time:
                    </Col>
                    <Col xs={3}>
                      <Form.Select
                        id="programHours"
                        size="sm"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            programHours: parseInt(e.target.value),
                          });
                          setIsFormDirty(true);
                        }}
                        value={formData.programHours}
                      >
                        {hours.map((i) => (
                          <option
                            value={i}
                            key={i}
                          >
                            {i < 12 ? i + " am" : i + " pm"}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col xs={3}>
                      <Form.Select
                        id="programMinutes"
                        size="sm"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            programMinutes: parseInt(e.target.value),
                          });
                          setIsFormDirty(true);
                        }}
                        value={formData.programMinutes}
                      >
                        {minutes.map((i) => (
                          <option
                            value={i}
                            key={i}
                          >
                            {i + " mins"}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                  <Row className="pt-2 align-items-center ">
                    <Col
                      sm={3}
                      className="align-self-center text-end "
                    >
                      Slot:
                    </Col>

                    <Col xs={3}>
                      <Form.Select
                        id="programSlotRuntimeHours"
                        value={formData.programSlotRuntimeHours}
                        size="sm"
                        className={
                          formData.programSlotRuntimeisDirty && "text-danger"
                        }
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            programSlotRuntimeHours: parseInt(e.target.value),
                            programSlotRuntime:
                              parseInt(e.target.value) * 60 +
                              formData.programSlotRuntimeMinutes,
                            programSlotRuntimeisDirty: true,
                          });
                          setIsFormDirty(true);
                        }}
                      >
                        {[...Array(7).keys()].map((hour) => (
                          <option
                            key={hour}
                            value={hour}
                          >
                            {hour} hrs
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col xs={3}>
                      <Form.Select
                        id="programSlotRuntimeMinutes"
                        value={formData.programSlotRuntimeMinutes}
                        size="sm"
                        className={
                          formData.programSlotRuntimeisDirty && "text-danger"
                        }
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            programSlotRuntimeMinutes: parseInt(e.target.value),
                            programSlotRuntime:
                              formData.programSlotRuntimeHours * 60 +
                              parseInt(e.target.value),
                            programSlotRuntimeisDirty: true,
                          });
                          setIsFormDirty(true);
                        }}
                      >
                        {[...Array(60 / 5).keys()].map((index) => (
                          <option
                            key={index}
                            value={index * 5}
                          >
                            {index * 5} mins
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programSlotRuntimeisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programSlotRuntimeisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>

                  <Row className="pt-2 align-items-center ">
                    <Col
                      sm={3}
                      className="align-self-center text-end "
                    >
                      Parental Rating:
                    </Col>
                    <Col sm={5}>
                      <Form.Group controlId="programParentalRating">
                        <Form.Control
                          className={
                            formData.programParentalRatingisDirty &&
                            "text-danger"
                          }
                          size="sm"
                          as="select"
                          value={formData.programParentalRating}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Parental Rating</option>
                          {parentalRatingLoading &&
                            "Loading Parental Ratings..."}
                          {parentalRatingError &&
                            "Error loading Parental Ratings"}
                          {parentalRating &&
                            parentalRating.map((rating) => (
                              <option
                                key={rating._id}
                                value={rating._id}
                              >
                                {rating.rating}
                              </option>
                            ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programParentalRatingisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programParentalRatingisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>

                  <Row className="pt-2 align-items-center ">
                    <Col
                      sm={3}
                      className="align-self-center text-end "
                    >
                      Genre:
                    </Col>
                    <Col sm={5}>
                      <Form.Group controlId="programGenre">
                        <Form.Control
                          className={
                            formData.programGenreisDirty && "text-danger"
                          }
                          size="sm"
                          as="select"
                          value={formData.programGenre}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Genre</option>
                          {genreLoading && "Loading genres..."}
                          {genreError && "Error loading genres"}
                          {genre &&
                            genre.map((genre) => (
                              <option
                                key={genre._id}
                                value={genre._id}
                              >
                                {genre.genre}
                              </option>
                            ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programGenreisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programGenreisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="pt-2 align-items-center ">
                    <Col
                      sm={3}
                      className="align-self-center text-end "
                    >
                      SubGenre:
                    </Col>
                    <Col sm={5}>
                      <Form.Group controlId="programSubgenre">
                        <Form.Control
                          className={
                            formData.programSubgenreisDirty && "text-danger"
                          }
                          size="sm"
                          as="select"
                          value={formData.programSubgenre}
                          onChange={handleFormChange}
                        >
                          <option value="">Select SubGenre</option>
                          {subgenreData &&
                            subgenreData.map((subgenre) => (
                              <option
                                key={subgenre._id}
                                value={subgenre._id}
                              >
                                {subgenre.SubGenre}
                              </option>
                            ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programSubgenreisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programSubgenreisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>

                  <Row className="pt-2 align-items-center ">
                    <Col
                      sm={3}
                      className="align-self-center text-end "
                    >
                      Series Link:
                    </Col>
                    <Col sm="1">
                      <FormCheck
                        type="checkbox"
                        isValid
                        checked={formData.programSeriesLinkLinkFlag}
                        onChange={(e) => {
                          const generateUniqueKey = (length) => {
                            const chars =
                              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                            let result = "";
                            for (let i = 0; i < length; i++) {
                              const randomIndex = Math.floor(
                                Math.random() * chars.length
                              );
                              result += chars[randomIndex];
                            }
                            return "KANS" + result;
                          };
                          setFormData((prevData) => {
                            const newProgramseriesLinkchainId =
                              prevData.programSeriesLinkChainId === ""
                                ? generateUniqueKey(16)
                                : prevData.programSeriesLinkChainId;
                            return {
                              ...prevData,
                              programSeriesLinkLinkFlag: e.target.checked,
                              programSeriesLinkChainId:
                                newProgramseriesLinkchainId,
                            };
                          });
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>

                  <Row className="pt-2 justify-content-evenly">
                    <Col
                      xs={3}
                      className={
                        formData.programIsLiveisDirty
                          ? "border border-2 border-danger text-danger mx-2 pt-2 pb-1"
                          : "border border-2 border-danger mx-2 pt-2 pb-1  "
                      }
                    >
                      <Row>
                        <Col xs={9}>
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programIsLive"}
                            label={"Is Live"}
                            checked={formData.programIsLive ? true : false}
                            defaultValue={formData.programIsLive}
                            onChange={handleCheckboxChange}
                          />
                        </Col>
                        <Col className="text-end ">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programIsLiveIsDirty"}
                            checked={
                              formData.programIsLiveisDirty ? true : false
                            }
                            defaultValue={formData.programIsLiveisDirty}
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programIsLiveisDirty: e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      xs={3}
                      className={
                        formData.programIsAvailableisDirty
                          ? "border border-2 border-success text-danger mx-2 pt-2 pb-1"
                          : "border border-2 border-success mx-2 pt-2 pb-1"
                      }
                    >
                      <Row>
                        <Col xs={9}>
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programIsAvailable"}
                            label={"Is Available"}
                            checked={formData.programIsAvailable ? true : false}
                            defaultValue={formData.programIsAvailable}
                            onChange={handleCheckboxChange}
                          />
                        </Col>
                        <Col className="text-end ">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programIsAvailableisDirty"}
                            checked={
                              formData.programIsAvailableisDirty ? true : false
                            }
                            defaultValue={formData.programIsAvailableisDirty}
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programIsAvailableisDirty: e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      xs={3}
                      className={
                        formData.programIsLockedisDirty
                          ? "border border-2 border-warning text-danger mx-2 pt-2 pb-1"
                          : "border border-2 border-warning mx-2 pt-2 pb-1"
                      }
                    >
                      <Row>
                        <Col xs={9}>
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programIsLocked"}
                            label={"Is Locked"}
                            checked={formData.programIsLocked ? true : false}
                            defaultValue={formData.programIsLocked}
                            onChange={handleCheckboxChange}
                          />
                        </Col>
                        <Col className="text-end ">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programIsLockedisDirty"}
                            checked={
                              formData.programIsLockedisDirty ? true : false
                            }
                            defaultValue={formData.programIsLockedisDirty}
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programIsLockedisDirty: e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-2 mt-2 align-items-center ">
                    <Col className="text-center text-bg-success ">File</Col>
                    <Col xs={10}></Col>
                  </Row>
                  <Row className="pt-2 mt-2 align-items-center ">
                    <Col
                      className="text-end  pt-2 "
                      xs={2}
                    >
                      Ident:
                    </Col>
                    <Col>
                      <Row className="align-items-center ">
                        <Col>
                          <Form.Group controlId="programPreRollFileIdent">
                            <Form.Control
                              className={
                                formData.programPreRollFileIdentisDirty &&
                                "text-danger"
                              }
                              size="sm"
                              as="select"
                              value={formData.programPreRollFileIdent}
                              onChange={handleFormChange}
                            >
                              <option value="">Select Ident</option>
                              {identsLoading && "Loading idents..."}
                              {identsError && "Error loading idents"}
                              {idents &&
                                idents.map((ident) => (
                                  <option
                                    key={ident._id}
                                    value={ident._id}
                                  >
                                    {ident.name}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm="1">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programPreRollFileIdentisDirty"}
                            checked={
                              formData.programPreRollFileIdentisDirty
                                ? true
                                : false
                            }
                            defaultValue={
                              formData.programPreRollFileIdentisDirty
                            }
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programPreRollFileIdentisDirty:
                                  e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-2 mt-2  border-0 border-top align-items-center ">
                    <Col
                      className="text-end  pt-2 "
                      xs={2}
                    >
                      Graphics:
                    </Col>
                    <Col>
                      <Row className="align-items-center ">
                        <Col>
                          <Select
                            name="programPreRollFileGraphics"
                            className={
                              formData.programPreRollFileGraphicsisDirty &&
                              "text-danger"
                            }
                            size="sm"
                            isMulti
                            closeMenuOnSelect={false}
                            options={graphics}
                            value={formData.programPreRollFileGraphics}
                            onChange={handleGraphicsChange}
                          />
                        </Col>
                        <Col sm="1">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programPreRollFileGraphicsisDirty"}
                            checked={
                              formData.programPreRollFileGraphicsisDirty
                                ? true
                                : false
                            }
                            defaultValue={
                              formData.programPreRollFileGraphicsisDirty
                            }
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programPreRollFileGraphicsisDirty:
                                  e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-3 align-items-center ">
                    <Col
                      sm={2}
                      className="text-end "
                    >
                      Add Breaks:
                    </Col>
                    <Col sm={5}>
                      <Form.Group controlId="programPreRollFileAddBreak">
                        <Form.Control
                          className={
                            formData.programPreRollFileAddBreakisDirty &&
                            "text-danger"
                          }
                          size="sm"
                          as="select"
                          value={formData.programPreRollFileAddBreak}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Add Breaks</option>
                          {addBreakChoices.map((addBreakChoice) => (
                            <option
                              key={addBreakChoice.addId}
                              value={addBreakChoice.addId}
                            >
                              {addBreakChoice.addBreak}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        isValid
                        id={"programPreRollFileAddBreakisDirty"}
                        checked={
                          formData.programPreRollFileAddBreakisDirty
                            ? true
                            : false
                        }
                        defaultValue={
                          formData.programPreRollFileAddBreakisDirty
                        }
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programPreRollFileAddBreakisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                    <Col
                      sm={1}
                      className="text-end "
                    >
                      Media:
                    </Col>
                    <Col
                      sm={2}
                      className="pt-2"
                    >
                      <Form.Group>
                        <Form.Control
                          id={"programPreRollFileMediaRuntime"}
                          className={
                            formData.programPreRollFileMediaRuntimeisDirty &&
                            "text-danger"
                          }
                          size="sm"
                          type="text"
                          placeholder="Enter run time"
                          value={formData.programPreRollFileMediaRuntime}
                          onChange={handleFormChange}
                          maxLength={3}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        isValid
                        id={"programPreRollFileMediaRuntimeisDirty"}
                        checked={
                          formData.programPreRollFileMediaRuntimeisDirty
                            ? true
                            : false
                        }
                        defaultValue={
                          formData.programPreRollFileMediaRuntimeisDirty
                        }
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programPreRollFileMediaRuntimeisDirty:
                              e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={9}></Col>
                    <Col
                      xs={2}
                      className="text-end"
                    >
                      <small>0 = default</small>
                    </Col>
                  </Row>

                  {/* Insert in Program Breaks */}
                  <Row className="pt-3 align-items-center ">
                    <Col
                      sm={3}
                      className="text-end "
                    >
                      In Program Breaks:
                    </Col>
                    <Col sm={4}>
                      <Form.Group controlId="programInProgramBreaks">
                        <Form.Control
                          className={
                            formData.programInProgramBreaksisDirty &&
                            "text-danger"
                          }
                          size="sm"
                          as="select"
                          value={formData.programInProgramBreaks}
                          onChange={handleFormChange}
                        >
                          {[...Array(3).keys()].map((number) => (
                            <option
                              key={number}
                              value={number}
                            >
                              {number === 0 ? "Zero" : number}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        isValid
                        id={"programInProgramBreaksisDirty"}
                        checked={
                          formData.programInProgramBreaksisDirty ? true : false
                        }
                        defaultValue={formData.programInProgramBreaksisDirty}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programInProgramBreaksisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="pt-3 align-items-center ">
                    <Col
                      sm={2}
                      className="text-end "
                    >
                      Paid Songs:
                    </Col>
                    <Col sm="1">
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        id={"programPreRollFileMediaPaidSongs"}
                        checked={
                          formData.programPreRollFileMediaPaidSongs
                            ? true
                            : false
                        }
                        isValid
                        defaultValue={formData.programPreRollFileMediaPaidSongs}
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programPreRollFileMediaPaidSongs: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="pt-2 mt-2 align-items-center">
                    <Col className="text-center text-bg-danger  ">Live</Col>
                    <Col xs={10}></Col>
                  </Row>
                  <Row className="pt-2 mt-2 align-items-center">
                    <Col
                      className="text-end  pt-2 "
                      xs={2}
                    >
                      Intro Ident:
                    </Col>
                    <Col>
                      <Row className="align-items-center ">
                        <Col>
                          <Form.Group controlId="programPreRollLiveIntroIdent">
                            <Form.Control
                              className={
                                formData.programPreRollLiveIntroIdentisDirty &&
                                "text-danger"
                              }
                              size="sm"
                              as="select"
                              value={formData.programPreRollLiveIntroIdent}
                              onChange={handleFormChange}
                            >
                              <option value="">Select Ident</option>
                              {identsLoading && "Loading idents..."}
                              {identsError && "Error loading idents"}
                              {idents &&
                                idents.map((ident) => (
                                  <option
                                    key={ident._id}
                                    value={ident._id}
                                  >
                                    {ident.name}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm="1">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programPreRollLiveIntroIdentisDirty"}
                            checked={
                              formData.programPreRollLiveIntroIdentisDirty
                                ? true
                                : false
                            }
                            defaultValue={
                              formData.programPreRollLiveIntroIdentisDirty
                            }
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programPreRollLiveIntroIdentisDirty:
                                  e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-2 mt-2 align-items-center">
                    <Col
                      className="text-end  pt-2 "
                      xs={2}
                    >
                      Ident:
                    </Col>
                    <Col>
                      <Row className="align-items-center ">
                        <Col>
                          <Form.Group controlId="programPreRollLiveIdent">
                            <Form.Control
                              className={
                                formData.programPreRollLiveIdentisDirty &&
                                "text-danger"
                              }
                              size="sm"
                              as="select"
                              value={formData.programPreRollLiveIdent}
                              onChange={handleFormChange}
                            >
                              <option value="">Select Ident</option>
                              {identsLoading && "Loading idents..."}
                              {identsError && "Error loading idents"}
                              {idents &&
                                idents.map((ident) => (
                                  <option
                                    key={ident._id}
                                    value={ident._id}
                                  >
                                    {ident.name}
                                  </option>
                                ))}
                            </Form.Control>
                          </Form.Group>
                        </Col>
                        <Col sm="1">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programPreRollLiveIdentisDirty"}
                            checked={
                              formData.programPreRollLiveIdentisDirty
                                ? true
                                : false
                            }
                            defaultValue={
                              formData.programPreRollLiveIdentisDirty
                            }
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programPreRollLiveIdentisDirty:
                                  e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-2 mt-2  border-0 border-top align-items-center">
                    <Col
                      className="text-end  pt-2 "
                      xs={2}
                    >
                      Graphics:
                    </Col>
                    <Col>
                      <Row className="align-items-center ">
                        <Col>
                          <Select
                            name="programPreRollLiveGraphics"
                            className={
                              formData.programPreRollLiveGraphicsisDirty &&
                              "text-danger"
                            }
                            size="sm"
                            isMulti
                            closeMenuOnSelect={false}
                            options={graphics}
                            value={formData.programPreRollLiveGraphics}
                            onChange={handleGraphicsChange}
                          />
                        </Col>
                        <Col sm="1">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programPreRollLiveGraphicsisDirty"}
                            checked={
                              formData.programPreRollLiveGraphicsisDirty
                                ? true
                                : false
                            }
                            defaultValue={
                              formData.programPreRollLiveGraphicsisDirty
                            }
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programPreRollLiveGraphicsisDirty:
                                  e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-2 mt-2  border-0 border-top">
                    <Col
                      className="text-end  pt-2 "
                      xs={2}
                    >
                      Media:
                    </Col>
                    <Col>
                      <Row className="align-items-center ">
                        <Col>
                          <Select
                            name="programPreRollLiveMedia"
                            className={
                              formData.programPreRollLiveMediaisDirty &&
                              "text-danger"
                            }
                            isMulti
                            closeMenuOnSelect={false}
                            options={graphics}
                            value={formData.programPreRollLiveMedia}
                            onChange={handleGraphicsChange}
                          />
                        </Col>
                        <Col sm="1">
                          <Form.Check // prettier-ignore
                            type={"checkbox"}
                            isValid
                            id={"programPreRollLiveMediaisDirty"}
                            checked={
                              formData.programPreRollLiveMediaisDirty
                                ? true
                                : false
                            }
                            defaultValue={
                              formData.programPreRollLiveMediaisDirty
                            }
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                programPreRollLiveMediaisDirty:
                                  e.target.checked,
                              }));
                              setIsFormDirty(true);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="pt-3 align-items-center ">
                    <Col
                      sm={2}
                      className="align-self-center text-end "
                    >
                      Add Breaks:
                    </Col>
                    <Col sm={5}>
                      <Form.Group controlId="programPreRollLiveAddBreak">
                        <Form.Control
                          className={
                            formData.programPreRollLiveAddBreakisDirty &&
                            "text-danger"
                          }
                          size="sm"
                          as="select"
                          value={formData.programPreRollLiveAddBreak}
                          onChange={handleFormChange}
                        >
                          <option value="">Select Add Breaks</option>
                          {addBreakChoices.map((addBreakChoice) => (
                            <option
                              key={addBreakChoice.addId}
                              value={addBreakChoice.addId}
                            >
                              {addBreakChoice.addBreak}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        isValid
                        id={"programPreRollLiveAddBreakisDirty"}
                        checked={
                          formData.programPreRollLiveAddBreakisDirty
                            ? true
                            : false
                        }
                        defaultValue={
                          formData.programPreRollLiveAddBreakisDirty
                        }
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programPreRollLiveAddBreakisDirty: e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                    <Col
                      sm={1}
                      className="align-self-center text-end "
                    >
                      Media:
                    </Col>
                    <Col sm={2}>
                      <Form.Group>
                        <Form.Control
                          id={"programPreRollLiveMediaRuntime"}
                          className={
                            formData.programPreRollLiveMediaRuntimeisDirty &&
                            "text-danger"
                          }
                          size="sm"
                          type="text"
                          placeholder="Enter run time"
                          value={formData.programPreRollLiveMediaRuntime}
                          onChange={handleFormChange}
                          maxLength={3}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="1">
                      <Form.Check // prettier-ignore
                        type={"checkbox"}
                        isValid
                        id={"programPreRollLiveMediaRuntimeisDirty"}
                        checked={
                          formData.programPreRollLiveMediaRuntimeisDirty
                            ? true
                            : false
                        }
                        defaultValue={
                          formData.programPreRollLiveMediaRuntimeisDirty
                        }
                        onChange={(e) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            programPreRollLiveMediaRuntimeisDirty:
                              e.target.checked,
                          }));
                          setIsFormDirty(true);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={9}></Col>
                    <Col
                      xs={2}
                      className="text-end"
                    >
                      <small>0 = default</small>
                    </Col>
                  </Row>
                  <Row className="p-2 mt-4 text-center  align-items-center">
                    <Col>
                      <Button
                        variant="success"
                        disabled={isFormDirty}
                        type="submit"
                        onClick={handleShow}
                      >
                        Add Program
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant="danger"
                        disabled={isFormDirty}
                        onClick={handleDeleteProgram}
                      >
                        Delete Program
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        variant="primary"
                        disabled={!isFormDirty}
                        type="submit"
                      >
                        Save Changes
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </small>
            </Col>
          </Row>
          <Row xs="6">
            <Col>
              <Modal
                show={showAddProgramModal}
                onHide={handleClose}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Add Program</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Form>
                    <Row className="mb-2 ">
                      <Col xs={4}>
                        <small>Select Program </small>
                      </Col>
                      <Col>
                        <Form.Select
                          id="programId"
                          size="sm"
                          onChange={handleProgramChange}
                          value={programFormData.programId}
                        >
                          <>
                            {programs &&
                              programs.map((program, i) => (
                                <option
                                  value={program._id}
                                  key={i}
                                >
                                  {program.name}
                                </option>
                              ))}
                          </>
                        </Form.Select>
                      </Col>
                    </Row>
                    <Row className="pt-2">
                      <Col
                        xs={4}
                        className="align-self-center text-end "
                      >
                        Start Time:
                      </Col>
                      <Col xs={3}>
                        <Form.Select
                          id="programHours"
                          size="sm"
                          onChange={handleProgramFormChange}
                          value={programFormData.programHours}
                        >
                          {hours.map((i) => (
                            <option
                              value={i}
                              key={i}
                            >
                              {i < 12 ? i + " am" : i + " pm"}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col xs={3}>
                        <Form.Select
                          id="programMinutes"
                          size="sm"
                          onChange={handleProgramFormChange}
                          value={programFormData.programMinutes}
                        >
                          {minutes.map((i) => (
                            <option
                              value={i}
                              key={i}
                            >
                              {i + " mins"}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Row>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleProgramInsert}
                  >
                    Save Program
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};
export default Templates;
